import type { Translator } from '@/i18n';
import { Icon } from './Icon';

interface Props {
  t: Translator['t'];
  mirrorRemote: boolean;
  remoteFit: 'cover' | 'contain';
  remoteControlBlocked: boolean;
  onToggleMirror: () => void;
  onToggleFit: () => void;
  onToggleBlock: () => void;
}

interface ItemProps {
  icon: string;
  label: string;
  active: boolean;
  onClick: () => void;
}

function Item({ icon, label, active, onClick }: ItemProps): React.JSX.Element {
  return (
    <button
      type="button"
      className={active ? 'advanced__item advanced__item--on' : 'advanced__item'}
      aria-pressed={active}
      onClick={onClick}
    >
      <span className="advanced__item-icon">
        <Icon name={icon} size={26} />
      </span>
      <span className="advanced__item-label">{label}</span>
    </button>
  );
}

/**
 * Розширена панель — світла шторка знизу, як у Flutter-клієнті.
 *
 * Секції «налаштування опонента» тут немає навмисно: у Flutter вона гейтиться
 * `!kIsWeb`, бо веб такими командами керувати не може.
 */
export function AdvancedControls({
  t,
  mirrorRemote,
  remoteFit,
  remoteControlBlocked,
  onToggleMirror,
  onToggleFit,
  onToggleBlock,
}: Props): React.JSX.Element {
  return (
    <div className="advanced">
      <div className="advanced__handle" />
      <p className="advanced__label">{t('mySettings')}</p>
      <div className="advanced__row">
        <Item icon="flip" label={t('mirror')} active={mirrorRemote} onClick={onToggleMirror} />
        <Item
          icon={remoteFit === 'cover' ? 'fit_screen' : 'crop_free'}
          label={remoteFit === 'cover' ? t('fitContain') : t('fitCover')}
          active={false}
          onClick={onToggleFit}
        />
        <Item
          icon={remoteControlBlocked ? 'lock' : 'lock_open'}
          label={t('blockRemoteControl')}
          active={remoteControlBlocked}
          onClick={onToggleBlock}
        />
      </div>
    </div>
  );
}
